import React from "react";
import { Link } from "react-router-dom";


const BreadcrumbNav = ({pathSegments}) => {
  
    return (
      <nav className="bg-gray-100 p-2">
        <ol className="list-none p-0 m-0 md:pl-[8vw]">
          {pathSegments.map((segment, index) => (
            <li key={index} className="inline">
              <Link className="text-cyan-500" to={segment.href}>{segment.caption}</Link>
              {index < pathSegments.length - 1 && <span className="mx-2 text-black">{'>'}</span>}
            </li>
          ))}
        </ol>
      </nav>
    );
  };
  
  export default BreadcrumbNav;